/**
 * PWA UI handler.
 *
 * @package SolutionCE
 */

(function () {
	'use strict';

	const isInstalledPwa =
		window.navigator.standalone === true ||
		window.matchMedia( '(display-mode: standalone)' ).matches;

	window.scePwaUi = {
		isPwa: isInstalledPwa
	};

	if ( ! isInstalledPwa ) {
		return;
	}
	document.documentElement.classList.add( 'is-pwa' );

	document.addEventListener(
		'DOMContentLoaded',
		function () {
			initNavigationLoader();
			initBackButton();
		}
	);

	window.addEventListener(
		'pageshow',
		function () {
			hideNavigationLoader();
			closeMenus();
		}
	);

	/**
	 * Initialise le loader de navigation.
	 *
	 * @return {void}
	 */
	function initNavigationLoader() {
		document.addEventListener(
			'click',
			function ( event ) {
				const trigger = event.target.closest( '.show-nav-loader' );

				if ( ! trigger ) {
					return;
				}

				const link = trigger.closest( 'a' );

				if ( ! link || ! shouldHandleLink( link ) ) {
					return;
				}

				closeMenus();
				showNavigationLoader();
			}
		);
	}

	/**
	 * Vérifie si le lien doit déclencher le loader.
	 *
	 * @param {HTMLAnchorElement} link Lien cliqué.
	 *
	 * @return {boolean}
	 */
	function shouldHandleLink( link ) {
		const href = link.getAttribute( 'href' );

		if (
			! href ||
			href.startsWith( '#' ) ||
			href.startsWith( 'mailto:' ) ||
			href.startsWith( 'tel:' ) ||
			link.target === '_blank' ||
			link.hasAttribute( 'download' ) ||
			link.hasAttribute( 'aria-controls' ) ||
			isParentMenuToggle( link )
		) {
			return false;
		}

		const url = new URL( link.href, window.location.href );

		return url.origin === window.location.origin;
	}

	/**
	 * Affiche le loader de navigation.
	 *
	 * @return {void}
	 */
	function showNavigationLoader() {
		document.documentElement.classList.add( 'is-app-loading' );
	}

	/**
	 * Masque le loader de navigation.
	 *
	 * @return {void}
	 */
	function hideNavigationLoader() {
		document.documentElement.classList.remove( 'is-app-loading' );
	}

	/**
	 * Initialise le bouton retour.
	 *
	 * @return {void}
	 */
	function initBackButton() {
		const backButton = document.getElementById( 'app-back-btn' );

		if ( ! backButton ) {
			return;
		}

		backButton.hidden = false;

		backButton.addEventListener(
			'click',
			function () {
				closeMenus();
				showNavigationLoader();

				if ( window.history.length > 1 ) {
					window.history.back();
					return;
				}

				window.location.href = '/';
			}
		);
	}

	/**
	 * Ferme le menu.
	 *
	 * @return {void}
	 */
	function closeMenus() {
		document.documentElement.classList.remove(
			'is-menu-open',
			'menu-open',
			'nav-open',
			'offcanvas-open'
		);

		document.body.classList.remove(
			'is-menu-open',
			'menu-open',
			'nav-open',
			'offcanvas-open'
		);

		document
			.querySelectorAll( '[aria-expanded="true"]' )
			.forEach(
				function ( element ) {
					element.setAttribute( 'aria-expanded', 'false' );
				}
			);
	}

	/**
	 * Vérifie si le lien sert à ouvrir un sous-menu.
	 *
	 * @param {HTMLAnchorElement} link Lien cliqué.
	 *
	 * @return {boolean}
	 */
	function isParentMenuToggle( link ) {
		const parent = link.closest( '.menu-item-has-children' );

		if ( ! parent ) {
			return false;
		}

		return parent.querySelector( ':scope > a' ) === link &&
			parent.querySelector( ':scope > .sub-menu' );
	}
})();